<template>
  <Modal :title="title" :showModal="showModal" class="edit-sale-account-form" @submit="submit">
    <template v-slot:body>
      <component v-if="modal" :is="modal" :config="modalConfig()" @close="$emit('close', $event)"></component>
      <div class="position-relative row general">
        <div class="position-relative form-group col-12">
          <label>Seller</label>
          <div class="input-group">
            <Select source="user/search" type="auto" field="order.user_read" :value="data.user_id" @changeValue="changeSeller" :disabled="action == 'view'"></Select>
          </div>
        </div>
        <div v-if="false">
          <div class="position-relative form-group col-12">
            <label>Watermark</label>
            <ThumbnailPreview :values="watermarkImage" @changeValues="changeThumbnailPreview" />
            <span class="btn btn-upload btn-outline-success">
              <label for="upload-media" class="m-0 w-100 cursor-pointer">Choose Images</label>
              <input type="file" id="upload-media" @change.stop.prevent="changeUploadImage" />
            </span>
          </div>
          <div class="position-relative form-group col-12">
            <label class="col-12 mb-2 p-0">Position</label>
            <Select :options="positionOptions()" :value="watermark.position || 'center'" @changeValue="changeWatermarkPosition"></Select>
          </div>
          <div class="position-relative form-group col-12 d-flex flex-wrap">
            <label class="col-12 mb-2 p-0">Size</label>
            <div class="input-group col-6 pl-0 pr-2">
              <input type="number" class="form-control has-tip" data-title="Width (%)" min="1" max="100" placeholder="Width" :value="watermark.width" @change.stop.prevent="changeWatermarkWidth" />
            </div>
            <div class="input-group col-6 pr-0 pl-2">
              <input type="number" class="form-control has-tip" data-title="Height (%)" min="1" max="100" placeholder="Height" :value="watermark.height" @change.stop.prevent="changeWatermarkHeight" />
            </div>
          </div>
          <div class="position-relative form-group col-12 d-flex flex-wrap">
            <label class="col-12 mb-2 p-0">Spacing</label>
            <div class="input-group col-6 pl-0 pr-2">
              <input type="number" class="form-control has-tip" data-title="Vertical (%)" min="1" max="100" placeholder="Vertical" :value="watermarkMargin[0]" @change.stop.prevent="changeWatermarkMarginVertical" />
            </div>
            <div class="input-group col-6 pr-0 pl-2">
              <input type="number" class="form-control has-tip" data-title="Horizontal (%)" min="1" max="100" placeholder="Horizontal" :value="watermarkMargin[1]" @change.stop.prevent="changeWatermarkMarginHorizontal" />
            </div>
          </div>
          <div class="position-relative form-group col-12 d-flex flex-wrap">
            <label class="col-12 mb-2 p-0">Opacity</label>
            <input type="number" class="form-control has-tip" data-title="Opacity (%)" min="1" max="100" placeholder="Opacity" :value="watermark.opacity" @change.stop.prevent="changeWatermarkOpacity" />
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'
import ThumbnailPreview from '@/components/ThumbnailPreview.vue'
export default {
  mixins: [Event],
  components: {
    ThumbnailPreview
  },
  data() {
    return {
      modal: false
    }
  },
  computed: {
    title() {
      return this.data.status == 'raw' ? 'Create Sale Account' : 'Edit Sale Account'
    },
    action() {
      return 'edit'
    },
    storeId() {
      return this.config?.storeId
    },
    accountId() {
      return this.config?.data?._id
    },
    getUri() {
      return `sale-account/get/${this.accountId}`
    },
    submitUri() {
      return `sale-account/update/${this.accountId}`
    },
    data() {
      return this.store.getter('', {})
    },
    meta() {
      return Object.assign(
        {
          watermark: {}
        },
        this.data.meta || {}
      )
    },
    watermark() {
      return Object.assign(
        {
          watermark: {
            position: 'top-right',
            width: '',
            height: '',
            margin: [],
            opacity: 100
          }
        },
        this.meta.watermark || {}
      )
    },
    watermarkImage() {
      let image = {}
      if (_.isObjectLike(this.watermark?.image?.files)) {
        image = {
          watermark: this.watermark.image
        }
      } else if (_.isString(this.watermark?.image) && String(this.watermark?.image).length > 0) {
        image.watermark = {
          files: [this.watermark.image]
        }
      }
      return image
    },
    watermarkMargin() {
      return Object.assign([3, 3], Object.values(this.watermark.margin || []))
    }
  },
  created() {
    this.store.commit('', {})
  },
  methods: {
    modalConfig() {
      return {
        action: this.action,
        storeId: this.storeId,
        accountId: this.accountId
      }
    },
    changeSeller(value) {
      this.store.commit('user_id', value)
    },
    positionOptions() {
      return [
        { id: 'center', text: 'Center' },
        { id: 'top-left', text: 'Top Left' },
        { id: 'top-right', text: 'Top Right' },
        { id: 'bottom-left', text: 'Bottom Left' },
        { id: 'bottom-right', text: 'Bottom Right' }
      ]
    },
    changeWatermarkPosition(value) {
      this.store.commit('meta.watermark.position', value)
    },
    changeUploadImage(e) {
      if (!_.isUndefined(e.target.files?.[0])) {
        this.store.commit('meta.watermark.image', { files: [e.target.files[0]] })
      }
      e.target.value = ''
    },
    changeThumbnailPreview() {
      this.store.commit('meta.watermark.image', '')
    },
    changeWatermarkWidth(e) {
      this.store.commit('meta.watermark.width', e.target.value)
    },
    changeWatermarkHeight(e) {
      this.store.commit('meta.watermark.height', e.target.value)
    },
    changeWatermarkMarginVertical(e) {
      this.store.commit('meta.watermark.margin.0', e.target.value)
    },
    changeWatermarkMarginHorizontal(e) {
      this.store.commit('meta.watermark.margin.1', e.target.value)
    },
    changeWatermarkOpacity(e) {
      this.store.commit('meta.watermark.opacity', e.target.value)
    },
    setUpData(rawData) {
      if (rawData.status == 'success') {
        let platform = _.pascalCase(rawData.data.platform || '')
        let action = _.pascalCase(this.action)
        let modal = `${platform}.SaleAccount.${action}`
        if (this.$options.components[modal] == undefined) {
          this.$options.components[modal] = this.$util.requireOrNull(`/platforms/${platform}/SaleAccount/Modal/${action}.vue`)
        }
        if (!_.isUndefined(rawData.data.platform) && this.$options.components[modal] !== null) {
          this.showModal = true
          rawData.data.meta = Object.assign({}, rawData.data.meta)
          this.store.commit('', rawData.data)
          this.modal = modal
        } else {
          this.$emit('close')
          this.$util.notify({
            text: 'Platforms not supported!',
            status: 'error'
          })
        }
      }
    },
    submit() {
      this.$emitter.emit('Modal.SaleAccount.Edit.Submit', this.data)
    }
  },
  props: {
    config: Object
  }
}
</script>
